<template>
    <h3 class="fancy">
        <span class="line"></span>
        <slot/>
        <span class="line"></span>
    </h3>
</template>

<script>
    export default {
        name: "TextStriked"
    };
</script>

<style scoped>
    .fancy {
        display: flex;
        align-items: center;
    }

    .fancy .line {
        flex: 1 0 auto;
        padding: 0 0.5rem;
        margin: 0 0.5rem;
        border-bottom: 1px solid var(--v-primary-base);
    }
</style>